import React, { useMemo, useState } from 'react'
import { useTranslation } from 'language/translator'

import {
  WidgetTagObject,
  WidgetTagStatusPatchAttributes,
  WidgetTagStatusPostAttributes
} from 'types/GlobalWidgetTag'

import Box from 'components_new/atoms/Box'

import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'

import {
  getStatusPreviewValue,
  translateStatusCondition,
  translateStatusValueLabel
} from './utils'

import Add from './add'
import Edit from './edit'

interface StatusSectionProps {
  createWidgetTagStatus: (
    body: WidgetTagStatusPostAttributes,
    tagId: string
  ) => void
  deleteWidgetTagStatus: (id: string, tagId: string) => void
  onClose: () => void
  tag: WidgetTagObject
  updateWidgetTagStatus: (
    id: string,
    body: WidgetTagStatusPatchAttributes,
    tagId: string
  ) => void
  widgetId: string
}

const StatusSection = (props: StatusSectionProps) => {
  const {
    createWidgetTagStatus,
    deleteWidgetTagStatus,
    onClose,
    tag,
    updateWidgetTagStatus
  } = props
  const { t } = useTranslation()

  /*-- status item to update/delete --*/
  const [statusItemId, setStatusItemId] = useState<string | null>(null)

  /*-- add --*/
  const [showAdd, setShowAdd] = useState<boolean>(false)

  const statusItem = useMemo(() => {
    if (statusItemId) {
      return tag.settings.status.items.find((item) => item.id === statusItemId)
    }

    return null
  }, [tag.settings.status.items, statusItemId])

  return (
    <>
      <SettingsGroup
        title={t('widgets', 'indication_title')}
        helperText={t('widgets', 'status_priority_helper_text')}
      >
        {tag.settings.status.items.map((item) => (
          <SettingsItem
            actions={
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: 6,
                  bgcolor: `${item.severity.selected}.main`
                }}
              />
            }
            key={item.id}
            onClick={() => setStatusItemId(item.id)}
            title={`${translateStatusValueLabel[tag.type]} ${
              translateStatusCondition[item.condition.selected][tag.type]
            }`}
            value={getStatusPreviewValue(item)}
          />
        ))}

        <SettingsItem
          color="success"
          onClick={() => setShowAdd(true)}
          title={t('global', 'add')}
          variant="add"
        />
      </SettingsGroup>

      {statusItem ? (
        <Edit
          deleteWidgetTagStatus={deleteWidgetTagStatus}
          onBack={() => setStatusItemId(null)}
          onClose={onClose}
          open={!!statusItem}
          statusItem={statusItem}
          tag={tag}
          updateWidgetTagStatus={updateWidgetTagStatus}
        />
      ) : null}

      <Add
        createWidgetTagStatus={createWidgetTagStatus}
        onCancel={() => setShowAdd(false)}
        onClose={onClose}
        open={showAdd}
        tag={tag}
      />
    </>
  )
}

export default StatusSection
